import React, { PureComponent } from "react";
import { Input } from "antd";

export default function InputInTable(props) {
  const { onChange } = props;
  function _onChange(text) {
    let newText = text.target.value;
    if (typeof newText === "string") {
      newText = newText.replace(/\n/g, "");
    }
    onChange && onChange(newText);
  }
  return (
    <Input.TextArea
      {...props}
      size="small"
      autoSize={{ minRows: 1 }}
      onChange={_onChange}
    />
  );
}
